module.exports = __webpack_public_path__ + "img/neonvalley.1a5c1ab4.svg";